import {mask} from 'vue-the-mask'
import axios from 'axios'
import state from '@/shared/http/repositories/geo/state'
import ActionsForm from '@/shared/mixins/actionsForm'
import BrowerRepository from '@/shared/http/repositories/realestate/broker'
import { toast, loading } from '@/shared/utils/UIHelper'
export default{
  mixins: [ActionsForm],
  props: ['id'],
  data () {
    return {
      name: 'Toaddbroker',
      mixins: [ActionsForm],
      edit: false,
      newUserData: {
        Nome: '',
        Email: '',
        DataNascimento: null,
        Creci: '',
        EstadoId: '',
        Rg: '',
        Cpf: '',
        Celular: '',
        Tipo: 1,
        TelefoneComercial: '',
        Cep: '',
        Cidade: '',
        Endereco: '',
        Bairro: '',
        Numero: '',
        Id: '',
        corretorID: ''
      },
      statesAcronym: [],
      title: 'ADICIONAR NOVO USUÁRIO'
    }
  },
  directives: {mask},
  mounted () {
    state.GetAllByCountryID('2375E209-7451-4A7A-A9BE-66BD2C392BE1')
      .then((res) => {
        let stateCompleteData = res.data.data
        stateCompleteData.forEach(stateData => {
          this.statesAcronym.push({value: stateData.id, text: stateData.sigla})
        })
      })
      .catch(() => {})
  },
  methods: {
    show (obj = {}) {
      if (Object.keys(obj).length !== 0) {
        this.newUserData.Nome = obj.nome
        this.newUserData.Email = obj.email
        this.newUserData.Creci = obj.creci
        this.newUserData.EstadoId = obj.estado.id
        this.newUserData.DataNascimento = obj.dataNascimento === null ? '' : obj.dataNascimento.replace('T00:00:00', '')
        this.newUserData.Rg = obj.rg
        this.newUserData.Celular = obj.celular
        this.newUserData.Cpf = obj.cpf
        this.newUserData.TelefoneComercial = obj.telefonecomercial
        this.newUserData.Cep = obj.cep
        this.newUserData.Cidade = obj.cidade
        this.newUserData.Endereco = obj.endereco
        this.newUserData.Bairro = obj.bairro
        this.newUserData.Numero = obj.numero
        this.newUserData.Id = obj.id
        this.newUserData.corretorID = obj.corretorID
        this.edit = true
        if (obj.tipo === 'Corretor') {
          this.newUserData.Tipo = 1
        } else {
          this.newUserData.Tipo = 2
        }
        this.title = 'EDITAR USUÁRIO'
      } else {
        Object.keys(this.newUserData).forEach((Element) => {
          if (Element !== 'dateBir  h') this.newUserData[Element] = ''
        })
        this.title = 'ADICIONAR NOVO USUÁRIO'
        this.edit = false
        this.newUserData.Tipo = 1
      }
      this.$refs['add-brower-modal'].show()
    },
    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    onSubmit (e) {
      loading.push()
      this.newUserData.credenciadaId = this.id
      if (this.edit === false) {
        BrowerRepository.PostTipoCorretor(this.newUserData)
          .then(res => {
            if (res.status === 200) {
              this.$refs['add-brower-modal'].hide()
              this.$emit('getAllBrokerByAccredited')
              toast.success(`Corretor/Administrador adicionado com sucesso`)
              loading.pop()
            }
          })
          .catch(() => {
            toast.error(`Erro ao adicionar o Corretor/Administrador`)
            loading.pop()
          })
      } else {
        this.newUserData.credenciadaId = this.id
        e.preventDefault()
        this.$validator.validateAll().then(result => {
          if (!result) {
            return
          }
          let sendData = {}

          Object.assign(sendData, this.newUserData)
          sendData.Cpf = sendData.Cpf.replace(/[().-]/gm, '')
          sendData.Celular = sendData.Celular.replace(/[().-]/gm, '')
          sendData.TelefoneComercial = sendData.TelefoneComercial.replace(/[().-]/gm, '')
          sendData.Cep = sendData.Cep.replace(/[().-]/gm, '')

          BrowerRepository.PutUpdateBrokerAdm(sendData)
            .then(res => {
              if (res.status === 200) {
                this.$emit('getAllBrokerByAccredited')
                this.$refs['add-brower-modal'].hide()
                toast.success(`Alterações salvas com sucesso`)
                loading.pop()
              }
            })
            .catch(() => {
              toast.error(`Erro ao salvar mudanças`)
              loading.pop()
            })
        })
      }
    },
    cancelNewBrower (e) {
      e.preventDefault()
      this.$refs['add-brower-modal'].hide()
      Object.keys(this.newUserData).forEach(key => {
        if (key === 'dateBirth') {
          this.newUserData[key] = null
        } else {
          this.newUserData[key] = ''
        }
      })
    },
    searchAndress () {
      axios({
        method: 'GET',
        url: `https://viacep.com.br/ws/${this.newUserData.Cep}/json/`
      }).then(res => {
        if (!('erro' in res.data)) {
          let data = res.data
          if (res.status === 200) {
            this.newUserData.Cidade = data.localidade
            this.newUserData.Endereco = data.logradouro
            this.newUserData.Bairro = data.bairro
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/toaddbroker/toaddbroker.js